/* eslint-disable @typescript-eslint/dot-notation */
import { Injectable } from '@angular/core';
import { RxdbAdaptorProvider } from '@database/infrastructure';
import { createRxDatabase, RxDatabase } from 'rxdb';
import { LoggingDatabaseContext } from './logging-database.dbcontext';
import { loggingSchema } from './logging.schema';

@Injectable()
export class LoggingDatabaseProvider {
	private database: RxDatabase<LoggingDatabaseContext>;

	public constructor(private adapterProvider: RxdbAdaptorProvider) {}

	public getDatabase() {
		if (this.database) {
			return this.database;
		}
		throw new Error('Database instance was not created. Make sure the database is created');
	}

	public async create(): Promise<RxDatabase<LoggingDatabaseContext>> {
		if (this.database) {
			return this.database;
		}

		const adapter = this.adapterProvider.getAdaptor();

		this.database = await createRxDatabase({
			name: 'logging',
			storage: adapter,
			ignoreDuplicate: true,
			localDocuments: true
		});

		const loggingCollections = {};
		loggingCollections['logs'] = {
			schema: loggingSchema
		};
		await this.database.addCollections(loggingCollections);

		return this.database;
	}
}
